import { createSlice } from "@reduxjs/toolkit";

export const OrderCodeSlice = createSlice({
  name: "translation-client",
  initialState: {
    isLoading: false,
    isError: false,
    OrderCodeData: [],
    message: "",
  },
  reducers: {
    onGetOrderCode: (state) => {
      return {
        ...state,
        isGetLoading: true,
        OrderCodeData: [],
      };
    },

    onGetOrderCodeSuccess: (state, { payload }) => {
      const { getData = [], message = "", status_code = "200" } = payload;
      return {
        ...state,
        isGetLoading: false,
        OrderCodeData: getData,
        getMessage: message,
        get_status_code: status_code,
      };
    },

    onGetOrderCodeError: (state, { payload }) => {
      const { getData = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        OrderCodeData: getData,
        getMessage: message,
        get_status_code: status_code,
        isGetLoading: false,
      };
    },
    onGeOrderCodeReset: (state) => {
      return {
        ...state,
        OrderCodeData: [],
        getMessage: "",
        get_status_code: null,
        isGetLoading: false,
      };
    },
  },
});

export const {
  onGeOrderCodeReset,
  onGetOrderCodeSuccess,
  onGetOrderCodeError,
  onGetOrderCode,
} = OrderCodeSlice.actions;

export default OrderCodeSlice.reducer;
